// @flow

import * as React from "react"
import UserStore from "shared/stores/UserStore"
import { observer } from "mobx-react-lite"

type Props = {
  children: React.Node,
  fallback?: Function | React.Node,
  has: Array<string>,
  oneOfPermissions?: boolean
}

const PermissionGuard = ({
  children,
  fallback,
  has,
  oneOfPermissions
}: Props) => {
  const renderFallback = () => {
    if (typeof fallback === "function") {
      return fallback()
    }
    return fallback || null
  }

  const checkPermissions = () =>
    oneOfPermissions
      ? UserStore.hasOneOfPermissions(has)
      : UserStore.hasPermissions(has)

  return checkPermissions() ? children : renderFallback()
}

export default (observer(PermissionGuard): any)
